import { APP_STORE_URL, GOOGLE_PLAY_URL } from "@/utils/appLinks";

// Official, unmodified badge artwork (Apple Marketing Tools, Google Play badge). App Store first, same height.
const STORES = [
  { href: APP_STORE_URL, src: "/badges/app-store-badge.svg", alt: "Download on the App Store", testId: "app-store-link" },
  { href: GOOGLE_PLAY_URL, src: "/badges/google-play-badge.png", alt: "Get it on Google Play", testId: "google-play-link" },
];

export const AppStoreButtons = ({ className = "", idPrefix = "", vertical = false, size = "h-11" }) => (
  <div className={`flex ${vertical ? "flex-col items-start" : "flex-wrap items-center"} gap-3 ${className}`}>
    {STORES.map(({ href, src, alt, testId }) => (
      <a
        key={testId}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`${idPrefix}${testId}`}
        className="inline-block rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
      >
        <img src={src} alt={alt} className={`${size} w-auto block`} draggable="false" />
      </a>
    ))}
  </div>
);

export const StoreTrademarks = ({ className = "" }) => (
  <p className={`text-[11px] leading-snug text-muted-foreground ${className}`} data-testid="store-trademarks">
    Apple and the Apple logo are trademarks of Apple Inc., registered in the U.S. and other countries. App Store is a service mark of Apple Inc.
    Google Play and the Google Play logo are trademarks of Google LLC.
  </p>
);
